import { render, staticRenderFns } from "./ResearchCombo.vue?vue&type=template&id=60019bcd&scoped=true&"
import script from "./ResearchCombo.vue?vue&type=script&lang=js&"
export * from "./ResearchCombo.vue?vue&type=script&lang=js&"
import style0 from "./ResearchCombo.vue?vue&type=style&index=0&id=60019bcd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60019bcd",
  null
  
)

export default component.exports